import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/404',
      name: '404',
      component: resolve => require(['../view/404.vue'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../view/login.vue'], resolve)
    },
    //系统设置(system)
    {
      path: '/system/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: 'trade',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'set',
              name: 'cms_set',
              component: resolve => require(['../view/system/trade/tradeset.vue'], resolve)
            },
            {
              path: 'query',
              component: resolve => require(['../view/system/trade/tradequery.vue'], resolve)
            }
          ]
        },
        {
          //系统设置首页
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/system/system.vue'], resolve)
            }
          ]
        },
        {
          //个人中心
          path: 'personal/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //常用代码设置
            {
              path: 'code/sort',
              component: resolve =>
                require(['../view/system/personal/codeset/codesort.vue'], resolve)
            },
            {
              path: 'code/sort/:type',
              component: resolve =>
                require(['../view/system/personal/codeset/codedetail.vue'], resolve)
            },
            //单位管理
            {
              path: 'agency',
              component: resolve => require(['../view/system/personal/agency/agency.vue'], resolve)
            },
            {
              path: 'agency/:id/extend',
              component: resolve =>
                require(['../view/system/personal/agency/agencyExtend.vue'], resolve)
            },
            //单位扩展属性
            {
              path: 'extend',
              component: resolve =>
                require(['../view/system/personal/extend/extendAttr.vue'], resolve)
            },
            //角色管理
            {
              path: 'role/show',
              component: resolve =>
                require(['../view/system/personal/role/roleManagement.vue'], resolve) //角色管理
            },
            {
              path: 'role/show/:role_id/relation',
              component: resolve =>
                require(['../view/system/personal/role/operatorRelation.vue'], resolve)
            },
            {
              path: 'dept/deptManagement',
              component: resolve =>
                require(['../view/system/personal/dept/deptManagement.vue'], resolve) //职员管理
            },
            {
              path: 'pos/posManagement',
              component: resolve =>
                require(['../view/system/personal/dept/positionManagement.vue'], resolve) //职位管理
            },
            {
              path: 'emp/employeeManagement',
              component: resolve =>
                require(['../view/system/personal/dept/employeeManagement.vue'], resolve) //职员管理
            },
            {
              path: 'area/areaManagement',
              component: resolve =>
                require(['../view/system/personal/area/areaManagement.vue'], resolve) //地区
            },
            //操作员管理
            {
              path: 'operator',
              component: resolve =>
                require(['../view/system/personal/operators/operator.vue'], resolve)
            },
            {
              path: 'companyManagement',
              component: resolve =>
                require([
                  '../view/system/personal/companyManagement/companyManagement.vue'
                ], resolve) //公司管理
            },
            {
              //参数设置
              path: 'parameter',
              component: resolve =>
                require(['../view/system/personal/parameter/parameterSet.vue'], resolve)
            }
          ]
        },
        {
          //菜单目录
          path: 'menuslist/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //权限分配
            {
              path: 'power',
              component: resolve =>
                require(['../view/system/menuslist/power/powerallot.vue'], resolve),
              children: [
                {
                  path: ':co_id/:role_id',
                  component: resolve =>
                    require(['../view/system/menuslist/power/powerdetail.vue'], resolve)
                }
              ]
            },
            //菜单目录
            {
              path: 'menus',
              component: resolve => require(['../view/system/menuslist/menus/menu.vue'], resolve),
              children: [
                {
                  path: ':sub_id/:menuId',
                  component: resolve =>
                    require(['../view/system/menuslist/menus/menubtn.vue'], resolve)
                },
                {
                  path: ':sub_id/:menuId/detail/:btnId',
                  component: resolve =>
                    require(['../view/system/menuslist/menus/btnDetail.vue'], resolve)
                }
              ]
            },
            //主键规则
            {
              path: 'majorkey',
              component: resolve =>
                require(['../view/system/menuslist/majorkey/majorkey.vue'], resolve)
            },
            //规则流水
            {
              path: 'rulenote',
              component: resolve =>
                require(['../view/system/menuslist/rulenote/rulenote.vue'], resolve)
            },
            {
              path: 'sysext',
              component: resolve => require(['../view/system/menuslist/sysext/sysext.vue'], resolve) //系统参数拓展
            },
            {
              //子系统管理
              path: 'subsystem',
              component: resolve =>
                require(['../view/system/menuslist/subsystem/subsystem.vue'], resolve)
            },
            {
              path: 'sysmessage',
              component: resolve =>
                require(['../view/system/menuslist/sysmessage/sysmessage.vue'], resolve) //系统信息
            },
            {
              path: 'notice',
              component: resolve => require(['../view/system/menuslist/notice/notice.vue'], resolve)
            },
            // 帮助中心
            {
              path: 'help',
              component: resolve => require(['../view/system/menuslist/help/help.vue'], resolve)
            },
            // 帮助中心扩展信息
            {
              path: 'helpExpand',
              component: resolve =>
                require(['../view/system/menuslist/helpExpand/helpExpand.vue'], resolve)
            },
            // 意见反馈管理
            {
              path: 'feedback',
              component: resolve =>
                require(['../view/system/menuslist/feedback/feedback.vue'], resolve)
            },
            {
              //缓存刷新
              path: 'refresh',
              component: resolve =>
                require(['../view/system/menuslist/refresh/refresh.vue'], resolve)
            },
            {
              //广告管理
              path: 'advertising',
              component: resolve =>
                require(['../view/system/menuslist/advertising/advertising.vue'], resolve)
            },
            {
              //推广管理
              path: 'promotion',
              component: resolve =>
                require(['../view/system/menuslist/promotion/promotion.vue'], resolve)
            },
            {
              //首页导航管理
              path: 'nav',
              component: resolve => require(['../view/system/menuslist/nav/nav.vue'], resolve)
            },
            {
              //商铺导航管理
              path: 'shopNav',
              component: resolve => require(['../view/system/menuslist/shopNav/shopNav.vue'], resolve)
            },
            {
              //服务协议管理
              path: 'service',
              component: resolve => require(['../view/system/menuslist/service/service.vue'], resolve)
            }
          ]
        },
        {
          //基本设置
          path: 'basic/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //商品分类
            {
              path: 'goodclass',
              component: resolve =>
                require(['../view/system/basicset/goodclass/goodType.vue'], resolve),
              children: [
                {
                  path: ':good_type',
                  component: resolve =>
                    require(['../view/system/basicset/goodclass/goods.vue'], resolve)
                }
              ]
            },
            // 商品属性
            {
              path: 'goodattr',
              component: resolve =>
                require(['../view/system/basicset/goodsattr/goodsAttr.vue'], resolve)
            },
            {
              path: 'goodattr/:type',
              component: resolve => require(['../view/system/basicset/gooddetail.vue'], resolve)
            },
            //商品属性类型
            {
              path: 'attrtype',
              component: resolve =>
                require(['../view/system/basicset/sortattrType/attrType.vue'], resolve)
            },
            //交易时间设置
            {
              path: 'transactionTime',
              component: resolve =>
                require(['../view/system/basicset/transactionTime/transactionTime.vue'], resolve)
            },
            //分类属性
            {
              path: 'sortattr',
              component: resolve => require(['../view/system/basicset/sortattr/sort.vue'], resolve),
              children: [
                {
                  path: ':sort_code/:cls_code',
                  component: resolve =>
                    require(['../view/system/basicset/sortattr/sortDetail.vue'], resolve)
                }
              ]
            }
          ]
        },
        {
          //会员管理
          path: 'member/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //会员管理
              path: 'mebManagement',
              component: resolve =>
                require(['../view/system/member/mebManagement/mebManagement.vue'], resolve)
            },
            {
              //标签管理
              path: 'tagManagement',
              component: resolve =>
                require(['../view/system/member/tagManagement/tagManagement.vue'], resolve)
            },
            {
              //状态控制
              path: 'mebState',
              component: resolve =>
                require(['../view/system/member/mebManagement/mebManagement.vue'], resolve)
            },
            {
              //会员详情
              path: 'mebManagement/detail/:memId',
              component: resolve =>
                require(['../view/system/member/mebManagement/memDetail.vue'], resolve)
            },
            {
              //会员客服
              path: 'mebManagement/memKf/:memId',
              component: resolve =>
                require(['../view/system/member/mebManagement/memKf.vue'], resolve)
            },
            {
              //会员操作员
              path: 'mebManagement/memOper/:memId',
              component: resolve =>
                require(['../view/system/member/mebManagement/memOper.vue'], resolve)
            },
            {
              //会员审核
              path: 'mebReview',
              component: resolve =>
                require(['../view/system/member/mebReview/mebReviewList.vue'], resolve)
            },
            {
              //会员审核-添加，编辑
              path: 'mebReview/Detail/:memId',
              component: resolve =>
                require(['../view/system/member/mebReview/mebReviewDetail.vue'], resolve)
            },
            {
              //会员审核-审核
              path: 'mebReview/examine/:memId',
              component: resolve =>
                require(['../view/system/member/mebReview/mebReviewDetail.vue'], resolve)
            },
            {
              //会员变更管理
              path: 'mebChange',
              component: resolve =>
                require(['../view/system/member/mebChange/mebChangeManagement.vue'], resolve)
            },
            {
              //权限组管理
              path: 'permissionGroup',
              component: resolve =>
                require(['../view/system/member/perGroup/permissionGroupManagement.vue'], resolve)
            },
            {
              //会员分析
              path: 'mebanaly',
              component: resolve =>
                require(['../view/system/member/mebAnaly/mebAnaly.vue'], resolve)
            },
            {
              //资质变更
              path: 'aptitude',
              component: resolve =>
                require(['../view/system/member/aptitudeChange/aptitude.vue'], resolve)
            },
            {
              //发票变更
              path: 'invoice',
              component: resolve =>
                require(['../view/system/member/invoiceChange/invoice.vue'], resolve)
            },
            {
              //会员变更
              path: 'mebmodify',
              component: resolve =>
                require(['../view/system/member/mebModify/mebModify.vue'], resolve)
            },
            {
              //会员类别统计
              path: 'typechart',
              component: resolve =>
                require(['../view/system/member/hyTypeChart/typeChart.vue'], resolve)
            },
            {
              //地域统计
              path: 'areachart',
              component: resolve =>
                require(['../view/system/member/areaChart/areaChart.vue'], resolve)
            },
            {
              //变更日志
              path: 'changeDate',
              component: resolve =>
                require(['../view/system/member/changeDate/changeDate.vue'], resolve)
            },
            {
              //审核日志
              path: 'auditDate',
              component: resolve =>
                require(['../view/system/member/auditDate/auditDate.vue'], resolve)
            },
            {
              //审核记录
              path: 'auditRecords',
              component: resolve =>
                require(['../view/system/member/auditDate/auditRecords.vue'], resolve)
            },
            {
              //会员在线统计
              path: 'online',
              component: resolve =>
                require(['../view/system/member/mebOnline/mebOnline.vue'], resolve)
            },
            {
              //未认证会员管理
              path: 'nonMember',
              component: resolve =>
                require(['../view/system/member/nonMember/nonMember.vue'], resolve)
            }
          ]
        },
        {
          //店铺管理
          path: 'shop/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //店铺审核列表
              path: 'audit',
              component: resolve =>
                require(['../view/system/shop/audit/list.vue'], resolve)
            },
            {
              //店铺审核
              path: 'examine',
              component: resolve =>
                require(['../view/system/shop/audit/examine.vue'], resolve)
            },
            {
              //店铺管理列表
              path: 'manage',
              component: resolve =>
                require(['../view/system/shop/manage/manage.vue'], resolve)
            },
            {
              //店铺审核日志
              path: 'auditLog',
              component: resolve =>
                require(['../view/system/shop/auditLog/auditLog.vue'], resolve)
            },
            {
              //单条审核日志
              path: 'auditInfo',
              component: resolve =>
                require(['../view/system/shop/auditInfo/auditInfo.vue'], resolve)
            },
          ]
        },
        {
          //短信查询
          path: 'sms/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //短信历史查询
              path: 'history',
              component: resolve => require(['../view/system/sms/history/history.vue'], resolve)
            },
            {
              //短信队列查询
              path: 'queue',
              component: resolve => require(['../view/system/sms/queue/queue.vue'], resolve)
            },
            {
              //短信模板配置
              path: 'template',
              component: resolve => require(['../view/system/sms/template/template.vue'], resolve)
            },
            {
              //短信白名单
              path: 'smswhite',
              component: resolve => require(['../view/system/sms/smswhite/smswhite.vue'], resolve)
            }
          ]
        },
        {
          //站内信查询
          path: 'msg/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //站内信队列查询
              path: 'queue',
              component: resolve => require(['../view/system/msg/queue/queue.vue'], resolve)
            },
            {
              //站内信模板配置
              path: 'template',
              component: resolve => require(['../view/system/msg/template/template.vue'], resolve)
            }
          ]
        },
        {
          //日志
          path: 'journal/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //会员登录日志
              path: 'hySign',
              component: resolve =>
                require(['../view/system/journal/memberSign/memberSign.vue'], resolve)
            },
            {
              //操作员登录日志
              path: 'czySign',
              component: resolve =>
                require(['../view/system/journal/operatorSign/operatorSign.vue'], resolve)
            },
            {
              //操作员操作日志
              path: 'czyOper',
              component: resolve =>
                require(['../view/system/journal/operatorOperation/operatorOperation.vue'], resolve)
            }
          ]
        }
      ]
    },
    //资金平台(fund)
    {
      path: '/fund/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          //资金平台首页
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/fund/fund.vue'], resolve)
            }
          ]
        },
        {
          // 平台
          path: 'platform/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //凭证录入
              path: 'voucher/entry',
              component: resolve => require(['../view/fund/platform/voucher/entry1.vue'], resolve)
            },
            {
              //凭证审核
              path: 'voucher/verify',
              component: resolve => require(['../view/fund/platform/voucher/verify.vue'], resolve)
            },
            {
              //凭证查询
              path: 'voucher/look',
              component: resolve => require(['../view/fund/platform/voucher/look.vue'], resolve)
            },
            {
              //调账录入
              path: 'zmAdjust/entry',
              component: resolve => require(['../view/fund/platform/zmAdjust/zmEntry.vue'], resolve)
            },
            {
              //调账审核
              path: 'zmAdjust/verify',
              component: resolve =>
                require(['../view/fund/platform/zmAdjust/zmVerify.vue'], resolve)
            },
            {
              //调账查询
              path: 'zmAdjust/look',
              component: resolve => require(['../view/fund/platform/zmAdjust/zmLook.vue'], resolve)
            },
            {
              //会员账户余额
              path: 'balance',
              component: resolve => require(['../view/fund/account/balance/balance.vue'], resolve)
            },
            {
              //交易总账单
              path: 'tradeBill',
              component: resolve =>
                require(['../view/fund/platform/tradeBill/tradeBill.vue'], resolve)
            },
            {
              //手续费汇总表
              path: 'sxfSummary',
              component: resolve =>
                require(['../view/fund/platform/sxfSummary/sxfSummary.vue'], resolve)
            },
            {
              //会员资金流水表
              path: 'mebFunds',
              component: resolve =>
                require(['../view/fund/platform/mebFunds/mebFunds.vue'], resolve)
            },
            {
              //交易日报表
              path: 'tradeDay',
              component: resolve =>
                require(['../view/fund/platform/tradeDay/tradeDay.vue'], resolve)
            }
          ]
        },
        {
          // 平安银行账户
          path: 'paBank/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'withdraw/cz',
              component: resolve => require(['../view/fund/paBank/withdraw/cz.vue'], resolve)
            },
            {
              path: 'withdraw/verify',
              component: resolve => require(['../view/fund/paBank/withdraw/verify.vue'], resolve)
            },
            {
              path: 'withdraw/query',
              component: resolve => require(['../view/fund/paBank/withdraw/query.vue'], resolve)
            },
            {
              path: 'withdraw/bill',
              component: resolve => require(['../view/fund/paBank/withdraw/bill.vue'], resolve)
            },
            {
              path: 'withdraw/member',
              component: resolve => require(['../view/fund/paBank/withdraw/member.vue'], resolve)
            },
            {
              path: 'withdraw/freeze',
              component: resolve =>
                require(['../view/fund/paBank/withdraw/freeze.vue'], resolve)
            },
            {
              path: 'withdraw/recharge',
              component: resolve => require(['../view/fund/paBank/withdraw/recharge.vue'], resolve)
            },
            {
              path: 'withdraw/platform',
              component: resolve => require(['../view/fund/paBank/withdraw/platform.vue'], resolve)
            },
            {
              path: 'withdraw/handling',
              component: resolve =>
                require(['../view/fund/paBank/withdraw/handling.vue'], resolve)
            },
            {
              path: 'withdraw/authentication',
              component: resolve =>
                require(['../view/fund/paBank/withdraw/authentication.vue'], resolve)
            },
            {
              path: 'withdraw/phoneReview',
              component: resolve =>
                require(['../view/fund/paBank/withdraw/phoneReview.vue'], resolve)
            },
            {
              path: 'withdraw/memberAccount',
              component: resolve =>
                require(['../view/fund/paBank/withdraw/memberAccount.vue'], resolve)
            },
            {
              path: 'withdraw/outstanding',
              component: resolve =>
                require(['../view/fund/paBank/withdraw/outstanding.vue'], resolve)
            }
          ]
        },
        {
          // 会员
          path: 'member/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'member/account',
              component: resolve => require(['../view/fund/member/member/account.vue'], resolve)
            }
          ]
        },
        {
          //基本设置
          path: 'basic/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              // 银行设置
              path: 'bank',
              component: resolve => require(['../view/fund/basicset/bank/bank.vue'], resolve)
            },
            {
              // 常用代码管理
              path: 'code/sort',
              component: resolve => require(['../view/fund/basicset/codeset/codesort.vue'], resolve)
            },
            {
              path: 'code/sort/:type',
              component: resolve =>
                require(['../view/fund/basicset/codeset/codedetail.vue'], resolve)
            },
            {
              //参数设置
              path: 'parameter',
              component: resolve =>
                require(['../view/fund/basicset/parameter/parameterSet.vue'], resolve)
            }
          ]
        },
        {
          //虚拟账户
          path: 'account/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //会员资金日记账
              path: 'dailyCapital',
              component: resolve =>
                require(['../view/fund/account/dailyCapital/dailyCapital.vue'], resolve)
            },
            {
              //会员可用日记账
              path: 'dailyUsable',
              component: resolve =>
                require(['../view/fund/account/dailyUsable/dailyUsable.vue'], resolve)
            },
            {
              //会员锁定日记账
              path: 'dailyLocked',
              component: resolve =>
                require(['../view/fund/account/dailyLocked/dailyLocked.vue'], resolve)
            },
            {
              //会员锁定明细表Summary
              path: 'lockedSchedule',
              component: resolve =>
                require(['../view/fund/account/lockedSchedule/lockedSchedule.vue'], resolve)
            },
            {
              //每日账户汇总表
              path: 'dailySummary',
              component: resolve =>
                require(['../view/fund/account/dailySummary/dailySummary.vue'], resolve)
            },
            {
              //历史账户汇总表balance
              path: 'historySummary',
              component: resolve =>
                require(['../view/fund/account/historySummary/historySummary.vue'], resolve)
            }
          ]
        }
      ]
    },
    //竞价(bid)
    {
      path: '/bid/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          //竞价首页
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/bid/bid.vue'], resolve)
            }
          ]
        },
        {
          //基本设置
          path: 'base/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //交易员管理
              path: 'trader',
              component: resolve => require(['../view/bid/base/trader/trader.vue'], resolve)
            },
            {
              //交易权限管理
              path: 'tradepower',
              component: resolve => require(['../view/bid/base/tradepower/tradePower.vue'], resolve)
            },
            {
              //常用代码管理
              path: 'code/sort',
              component: resolve => require(['../view/bid/base/codeset/codesort.vue'], resolve)
            },
            {
              path: 'code/sort/:type',
              component: resolve => require(['../view/bid/base/codeset/codedetail.vue'], resolve)
            },
            {
              //手续费设置
              path: 'poundage',
              component: resolve => require(['../view/bid/base/poundage/cost.vue'], resolve)
            },
            {
              //交易商管理
              path: 'dealers',
              component: resolve => require(['../view/bid/base/dealers/dealers.vue'], resolve)
            },
            {
              //保证金设置
              path: 'deposit',
              component: resolve => require(['../view/bid/base/deposit/deposit.vue'], resolve)
            },
            {
              //参数设置
              path: 'parameter',
              component: resolve =>
                require(['../view/bid/base/parameter/parameterSet.vue'], resolve)
            }
          ]
        },
        {
          //商品管理
          path: 'goods/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //品名管理
            {
              path: 'name',
              component: resolve => require(['../view/bid/goods/goodname/nameManage.vue'], resolve),
              children: [
                {
                  path: ':cls_code',
                  component: resolve =>
                    require(['../view/bid/goods/goodname/nameDetail.vue'], resolve)
                },
                {
                  path: ':cls_code/attr/:name_id',
                  component: resolve =>
                    require(['../view/bid/goods/goodname/nameAttr.vue'], resolve)
                }
              ]
            },
            //所有商品列表
            {
              path: 'goodslist',
              component: resolve =>
                require(['../view/bid/goods/goodslist/goodsPlate.vue'], resolve),
              children: [
                {
                  path: ':plate_id',
                  component: resolve =>
                    require(['../view/bid/goods/goodslist/goodslist.vue'], resolve)
                }
              ]
            },
            //商品默认设置
            {
              path: 'goodset',
              component: resolve => require(['../view/bid/goods/goodset/defaultSet.vue'], resolve),
              children: [
                {
                  path: ':com_type',
                  component: resolve => require(['../view/bid/goods/goodset/setlist.vue'], resolve)
                }
              ]
            },
            //商品审核
            {
              path: 'goodcheck',
              component: resolve =>
                require(['../view/bid/goods/goodscheck/goodcheck.vue'], resolve),
              children: [
                {
                  path: ':check_type',
                  component: resolve =>
                    require(['../view/bid/goods/goodscheck/goodCheckList.vue'], resolve)
                }
              ]
            },
            //当前交易商品
            {
              path: 'curtGoods',
              component: resolve =>
                require(['../view/bid/goods/curtGoods/curtGoodsPlate.vue'], resolve),
              children: [
                {
                  path: ':plate_id',
                  component: resolve =>
                    require(['../view/bid/goods/curtGoods/curtGoods.vue'], resolve)
                }
              ]
            }
          ]
        },
        {
          //交易管理
          path: 'trade/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //交易节设置
              path: 'tradenode',
              component: resolve => require(['../view/bid/trade/tradenode/tradeNode.vue'], resolve),
              children: [
                {
                  path: ':trade_type',
                  component: resolve =>
                    require(['../view/bid/trade/tradenode/tradeNodeList.vue'], resolve)
                }
              ]
            },
            {
              //系统板块配置
              path: 'systemplate',
              component: resolve =>
                require(['../view/bid/trade/systemplate/sysmplate.vue'], resolve)
            },
            {
              //交易管理
              path: 'jymanage',
              component: resolve =>
                require(['../view/bid/trade/jyManage/jyManageTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/trade/jyManage/jyManageDetail.vue'], resolve)
                }
              ]
            }
          ]
        },
        {
          //会费管理
          path: 'membership/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //会费添加
              path: 'costadd',
              component: resolve => require(['../view/bid/membership/costadd/costAdd.vue'], resolve)
            },
            {
              path: 'costadd/:cost_id',
              component: resolve =>
                require(['../view/bid/membership/costadd/costDetail.vue'], resolve)
            },
            {
              //会费审核
              path: 'costreview',
              component: resolve =>
                require(['../view/bid/membership/costreview/costReview.vue'], resolve)
            },
            {
              path: 'costreview/:cost_id',
              component: resolve =>
                require(['../view/bid/membership/costreview/costReviewDetail.vue'], resolve)
            },
            {
              //会费分类
              path: 'costclass',
              component: resolve =>
                require(['../view/bid/membership/costclass/costType.vue'], resolve)
            },
            {
              //会费查询
              path: 'costInfo',
              component: resolve =>
                require(['../view/bid/membership/costInfo/costInfo.vue'], resolve)
            }
          ]
        },
        {
          //合同管理
          path: 'contract/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //合同列表
              path: 'htlist',
              component: resolve =>
                require(['../view/bid/contract/contractList/htTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/contract/contractList/htList.vue'], resolve)
                },
                {
                  path: ':tab_id/detail/:ht_id',
                  component: resolve =>
                    require(['../view/bid/contract/contractList/htDetail.vue'], resolve)
                }
              ]
            }
          ]
        },
        {
          //竞买查询
          path: 'compete/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //场次报价查询
              path: 'offer',
              component: resolve => require(['../view/bid/compete/offer/offerTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/compete/offer/offerList.vue'], resolve)
                }
              ]
            },
            {
              //历史报价查询
              path: 'historyOffer',
              component: resolve =>
                require(['../view/bid/compete/historyOffer/historyOfferTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/compete/historyOffer/historyOffer.vue'], resolve)
                }
              ]
            },
            {
              //非法报价查询
              path: 'illegalOffer',
              component: resolve =>
                require(['../view/bid/compete/illegalOffer/illegalTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/compete/illegalOffer/illegal.vue'], resolve)
                }
              ]
            },
            {
              //场次成交汇总
              path: 'dealSummary',
              component: resolve =>
                require(['../view/bid/compete/dealSummary/summaryTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/compete/dealSummary/summaryList.vue'], resolve)
                }
              ]
            },
            {
              //场次成交明细
              path: 'dealDetail',
              component: resolve =>
                require(['../view/bid/compete/dealDetail/detailTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/compete/dealDetail/detailList.vue'], resolve)
                }
              ]
            },
            {
              //历史成交查询
              path: 'historyDeal',
              component: resolve =>
                require(['../view/bid/compete/historyDeal/historyDealTab.vue'], resolve),
              children: [
                {
                  path: ':tab_id',
                  component: resolve =>
                    require(['../view/bid/compete/historyDeal/historyDeal.vue'], resolve)
                }
              ]
            },
            {
              //成交统计报表
              path: 'dealStatistics',
              component: resolve =>
                require(['../view/bid/compete/dealStatistics/dealStatistics.vue'], resolve)
            },
            {
              //成交排行榜
              path: 'dealRanking',
              component: resolve =>
                require(['../view/bid/compete/dealRanking/dealRanking.vue'], resolve)
            },
            {
              //成交报表
              path: 'dealReport',
              component: resolve =>
                require(['../view/bid/compete/dealReport/dealReport.vue'], resolve)
            },
            {
              //销售统计报表
              path: 'saleReport',
              component: resolve =>
                require(['../view/bid/compete/saleReport/saleReport.vue'], resolve)
            },
            {
              //成交排名报表
              path: 'dealRankReport',
              component: resolve =>
                require(['../view/bid/compete/dealRankReport/dealRankReport.vue'], resolve)
            }
          ]
        },
        {
          //会费报表
          path: 'report/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //周会费报表
              path: 'week',
              component: resolve => require(['../view/bid/report/week/weekReport.vue'], resolve)
            },
            {
              //月会费报表
              path: 'month',
              component: resolve => require(['../view/bid/report/month/monthReport.vue'], resolve)
            },
            {
              //年会费报表
              path: 'year',
              component: resolve => require(['../view/bid/report/year/yearReport.vue'], resolve)
            }
          ]
        }
      ]
    },
    {
      //挂牌(listed)
      path: '/listed/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/listed/listed.vue'], resolve)
            }
          ]
        },
        {
          //基础设置
          path: 'base/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //常用代码设置
            {
              path: 'code/sort',
              component: resolve => require(['../view/listed/base/cyCode/code.vue'], resolve)
            },
            {
              path: 'code/sort/:type',
              component: resolve => require(['../view/listed/base/cyCode/codeDetail.vue'], resolve)
            },
            {
              //条款模板设置
              path: 'clause',
              component: resolve => require(['../view/listed/base/clause/clause.vue'], resolve),
              children: [
                {
                  //模板
                  path: ':mb_id',
                  component: resolve =>
                    require(['../view/listed/base/clause/clauseList.vue'], resolve)
                }
              ]
            },
            {
              //参数设置
              path: 'parameter',
              component: resolve =>
                require(['../view/listed/base/parameter/parameter.vue'], resolve)
            }
          ]
        },
        {
          //物资设置
          path: 'wz/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //物资大类设置
              path: 'large',
              component: resolve => require(['../view/listed/wzset/large/largeClass.vue'], resolve)
            },
            {
              //物资品种设置
              path: 'varieties',
              component: resolve =>
                require(['../view/listed/wzset/varieties/varieties.vue'], resolve)
            },
            {
              //物资品名设置
              path: 'product',
              component: resolve => require(['../view/listed/wzset/product/product.vue'], resolve)
            },
            {
              //物资产地设置
              path: 'origin',
              component: resolve => require(['../view/listed/wzset/origin/origin.vue'], resolve)
            },
            {
              //物资材质设置
              path: 'material',
              component: resolve => require(['../view/listed/wzset/material/material.vue'], resolve)
            },
            {
              //物资代码设置
              path: 'code',
              component: resolve => require(['../view/listed/wzset/wzCode/code.vue'], resolve)
            },
            {
              //仓库设置
              path: 'warehouse',
              component: resolve => require(['../view/listed/wzset/warehouse/ware.vue'], resolve)
            },
            {
              //交易费用设置
              path: 'tradecost',
              component: resolve => require(['../view/listed/wzset/tradecost/cost.vue'], resolve)
            },
            {
              //挂牌保证金设置
              path: 'bond',
              component: resolve => require(['../view/listed/wzset/bond/bond.vue'], resolve)
            }
          ]
        },
        {
          //交易管理
          path: 'trade/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //发货单管理
              path: 'deliver',
              component: resolve => require(['../view/listed/trade/deliver/list.vue'], resolve)
            },
            {
              //合同管理
              path: 'ht',
              component: resolve => require(['../view/listed/trade/ht/list.vue'], resolve)
            },
            {
              //提单管理
              path: 'bill',
              component: resolve => require(['../view/listed/trade/bill/list.vue'], resolve)
            },
            {
              //发票管理
              path: 'invoice',
              component: resolve => require(['../view/listed/trade/invoice/list.vue'], resolve)
            },
            {
              //结算管理
              path: 'manage',
              component: resolve => require(['../view/listed/trade/manage/manage.vue'], resolve)
            },
            {
              //违约处理
              path: 'breaching',
              component: resolve =>
                require(['../view/listed/trade/breaching/breaching.vue'], resolve)
            },
            {
              //违约审核
              path: 'check',
              component: resolve => require(['../view/listed/trade/check/check.vue'], resolve)
            },
            {
              //违约查看
              path: 'breaklook',
              component: resolve =>
                require(['../view/listed/trade/breaklook/breaklook.vue'], resolve)
            }
          ]
        }
      ]
    },
    {
      //求购管理(wantbuy)
      path: '/wantbuy/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/wantBuy/index.vue'], resolve)
            }
          ]
        },
        {
          //求购管理
          path: 'want/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //求购审核
            {
              path: 'verify',
              component: resolve => require(['../view/wantBuy/want/verifyList.vue'], resolve)
            },
            {
              path: 'manage',
              component: resolve => require(['../view/wantBuy/want/manage.vue'], resolve)
            }
          ]
        }
      ]
    },
    {
      //竞卖管理(auction)
      path: '/auction/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/auction/auction.vue'], resolve)
            }
          ]
        },
        {
          //竞拍管理
          path: 'bid/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //竞拍申请审核
            {
              path: 'verify',
              component: resolve => require(['../view/auction/bid/verify/verify.vue'], resolve)
            },
            //竞拍委托管理
            {
              path: 'trust',
              component: resolve => require(['../view/auction/bid/trust/trust.vue'], resolve)
            },
            {
              path: 'trust/:tr_id/resource',
              component: resolve => require(['../view/auction/bid/trust/resource.vue'], resolve)
            },
            {
              path: 'trust/:tr_id/member',
              component: resolve => require(['../view/auction/bid/trust/member.vue'], resolve)
            },
            //竞拍管理
            {
              path: 'manage',
              component: resolve => require(['../view/auction/bid/manage/manage.vue'], resolve)
            },
            {
              //-资源信息
              path: 'manage/:tr_id/resource',
              component: resolve => require(['../view/auction/bid/manage/resource.vue'], resolve)
            },
            {
              //-参加会员列表
              path: 'manage/:tr_id/member',
              component: resolve => require(['../view/auction/bid/manage/member.vue'], resolve)
            },
            {
              //-评标结果
              path: 'manage/:tr_id/result',
              component: resolve => require(['../view/auction/bid/manage/result.vue'], resolve)
            },
            {
              //-报价信息
              path: 'manage/:tr_id/offer',
              component: resolve => require(['../view/auction/bid/manage/offer.vue'], resolve)
            },
            //保证金管理
            {
              path: 'bzj',
              component: resolve => require(['../view/auction/bid/bzj/bzj.vue'], resolve)
            },
            {
              path: 'panel',
              component: resolve => require(['../view/auction/bid/panel/panel.vue'], resolve)
            },
            {
              path: 'panelHistory/:id',
              component: resolve => require(['../view/auction/bid/panel/panelHistory.vue'], resolve)
            },
            
            

            {
              path: 'fee',
              component: resolve => require(['../view/auction/bid/fee/fee.vue'], resolve)
            }
          ]
        },
        {
          //项目信息管理
          path: 'material/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //参数设置
              path: 'manage',
              component: resolve =>
                require(['../view/auction/material/manage.vue'], resolve)
            },
            {
              //参数设置
              path: 'verify',
              component: resolve =>
                require(['../view/auction/material/verifyList.vue'], resolve)
            },
            {
              //参数设置
              path: 'add/:memId',
              component: resolve =>
                require(['../view/auction/material/add.vue'], resolve)
            },
            {
              //参数设置
              path: 'detail/:meterial_id/:list',
              component: resolve =>
                require(['../view/auction/material/detail.vue'], resolve)
            },
          ]
        },
        {
          //基本设置
          path: 'base/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //参数设置
              path: 'parameter',
              component: resolve =>
                require(['../view/auction/base/parameter/parameter.vue'], resolve)
            },

          ]
        }
      ]
    },
    {
      //竞买管理(purchase)
      path: '/purchase/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/purchase/auction.vue'], resolve)
            }
          ]
        },
        {
          //竞拍管理
          path: 'bid/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //竞拍申请审核
            {
              path: 'verify',
              component: resolve => require(['../view/purchase/bid/verify/verify.vue'], resolve)
            },
            //竞拍委托管理
            {
              path: 'trust',
              component: resolve => require(['../view/purchase/bid/trust/trust.vue'], resolve)
            },
            {
              path: 'trust/:tr_id/resource',
              component: resolve => require(['../view/purchase/bid/trust/resource.vue'], resolve)
            },
            {
              path: 'trust/:tr_id/member',
              component: resolve => require(['../view/purchase/bid/trust/member.vue'], resolve)
            },
            //竞拍管理
            {
              path: 'manage',
              component: resolve => require(['../view/purchase/bid/manage/manage.vue'], resolve)
            },
            {
              //-资源信息
              path: 'manage/:tr_id/resource',
              component: resolve => require(['../view/purchase/bid/manage/resource.vue'], resolve)
            },
            {
              //-参加会员列表
              path: 'manage/:tr_id/member',
              component: resolve => require(['../view/purchase/bid/manage/member.vue'], resolve)
            },
            {
              //-评标结果
              path: 'manage/:tr_id/result',
              component: resolve => require(['../view/purchase/bid/manage/result.vue'], resolve)
            },
            {
              //-报价信息
              path: 'manage/:tr_id/offer',
              component: resolve => require(['../view/purchase/bid/manage/offer.vue'], resolve)
            },
            //保证金管理
            {
              path: 'bzj',
              component: resolve => require(['../view/purchase/bid/bzj/bzj.vue'], resolve)
            }
          ]
        },
        {
          //基本设置
          path: 'base/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //参数设置
              path: 'parameter',
              component: resolve =>
                require(['../view/purchase/base/parameter/parameter.vue'], resolve)
            },

          ]
        }
      ]
    },
    // {//竞买管理(purchase)
    //   path:'/purchase/:subsite_id',
    //   component: resolve => require(['../components/container.vue'],resolve),
    //   children:[
    //     {
    //       path:'',
    //       component: resolve => require(['../components/system.vue'],resolve),
    //       children:[
    //         {
    //           path:'index',
    //           meta:{
    //             isIndex:true,
    //           },
    //           component: resolve => require(['../view/purchase/auction.vue'],resolve),
    //         },
    //       ]
    //     },
    //     {//竞拍管理
    //       path:'bid/:menu_id',
    //       component: resolve => require(['../components/system.vue'],resolve),
    //       children:[
    //         //竞拍申请审核
    //         {
    //           path:'verify',
    //           component: resolve => require(['../view/purchase/bid/verify/verify.vue'],resolve),
    //         },
    //         //竞拍委托管理
    //         {
    //           path:'trust',
    //           component: resolve => require(['../view/purchase/bid/trust/trust.vue'],resolve),
    //         },
    //         {
    //           path:'trust/:tr_id/resource',
    //           component: resolve => require(['../view/purchase/bid/trust/resource.vue'],resolve),
    //         },
    //         {
    //           path:'trust/:tr_id/member',
    //           component: resolve => require(['../view/purchase/bid/trust/member.vue'],resolve),
    //         },
    //         //竞拍管理
    //         {
    //           path:'manage',
    //           component: resolve => require(['../view/purchase/bid/manage/manage.vue'],resolve),
    //         },
    //         {//-资源信息
    //           path:'manage/:tr_id/resource',
    //           component: resolve => require(['../view/purchase/bid/manage/resource.vue'],resolve),
    //         },
    //         {//-参加会员列表
    //           path:'manage/:tr_id/member',
    //           component: resolve => require(['../view/purchase/bid/manage/member.vue'],resolve),
    //         },
    //         {//-评标结果
    //           path:'manage/:tr_id/result',
    //           component: resolve => require(['../view/purchase/bid/manage/result.vue'],resolve),
    //         },
    //         {//-报价信息
    //           path:'manage/:tr_id/offer',
    //           component: resolve => require(['../view/purchase/bid/manage/offer.vue'],resolve),
    //         },
    //       ]
    //     },
    //     {//基本设置
    //       path:'base/:menu_id',
    //       component: resolve => require(['../components/system.vue'],resolve),
    //       children:[
    //         {//参数设置
    //           path:'parameter',
    //           component: resolve => require(['../view/purchase/base/parameter/parameter.vue'],resolve),
    //         },
    //       ]
    //     },
    //     {//竞价采购报表
    //       path:'statistics/:menu_id',
    //       component: resolve => require(['../components/system.vue'],resolve),
    //       children:[
    //         {//竞价采购情况统计
    //           path:'procurement',
    //           component: resolve => require(['../view/purchase/statistics/procurement/procurement.vue'],resolve),
    //         },
    //       ]
    //     }
    //   ]
    // },
    {
      //挂牌管理(quote)
      path: '/quote/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/quote/quote.vue'], resolve)
            }
          ]
        },
        {
          //基本设置
          path: 'base/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //-参数设置
              path: 'parameter',
              component: resolve => require(['../view/quote/base/parameter/parameter.vue'], resolve)
            },
            {
              //挂牌信用设置
              path: 'trustworthiness',
              component: resolve =>
                require(['../view/quote/base/trustworthiness/trustworthiness.vue'], resolve)
            }
          ]
        },
        {
          //挂牌管理
          path: 'listed/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //-资源
              path: 'checklist',
              component: resolve => require(['../view/quote/listed/checkList/checkList.vue'], resolve)
            },
            {
              //-资源
              path: 'resource',
              component: resolve => require(['../view/quote/listed/resource/resource.vue'], resolve)
            },
            {
              //-审核 查看
              path: 'resourceLook',
              component: resolve => require(['../view/quote/listed/resource/resourceLook.vue'], resolve)
            },
            {
              //-查询
              path: 'query',
              component: resolve => require(['../view/quote/listed/query/query.vue'], resolve)
            },
            {
              //-洽谈
              path: 'talk',
              component: resolve => require(['../view/quote/listed/talk/list.vue'], resolve)
            }
          ]
        }
      ]
    },
    {
      //采购管理(acquire)
      path: '/acquire/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/acquire/acquire.vue'], resolve)
            }
          ]
        },
        {
          //采购管理
          path: 'procure/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //采购资源
              path: 'resource',
              component: resolve => require(['../view/acquire/procure/resource/list.vue'], resolve)
            },
            {
              //采购查询
              path: 'query',
              component: resolve => require(['../view/acquire/procure/query/list.vue'], resolve)
            }
          ]
        },
        {
          //基本设置
          path: 'base/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //-参数设置
              path: 'parameter',
              component: resolve => require(['../view/quote/base/parameter/parameter.vue'], resolve)
            }
          ]
        }
      ]
    },
    //cms
    {
      path: '/cms',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: 'func',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              component: resolve => require(['../view/cms/cms.vue'], resolve)
            },
            {
              path: 'set',
              component: resolve => require(['../view/cms/trade/tradeset.vue'], resolve)
            },
            {
              path: 'query',
              component: resolve => require(['../view/cms/trade/tradequery.vue'], resolve)
            }
          ]
        }
      ]
    },
    //大数据
    {
      path: '/bigdata/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          //大数据首页
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/bigdata/bigdata.vue'], resolve)
            }
          ]
        },
        {
          path: 'func',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              component: resolve => require(['../view/bigdata/bigdata.vue'], resolve)
            },
            {
              path: 'set',
              component: resolve => require(['../view/bigdata/trade/tradeset.vue'], resolve)
            },
            {
              path: 'query',
              component: resolve => require(['../view/bigdata/trade/tradequery.vue'], resolve)
            }
          ]
        }
      ]
    },
    {
      path: '/platform',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: 'func',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              component: resolve => require(['../view/platform/platform.vue'], resolve)
            },
            {
              path: 'companyManagement',
              component: resolve =>
                require(['../view/platform/memberManagement/companyManagement.vue'], resolve)
            },
            {
              path: 'companyManagement/edit',
              component: resolve =>
                require(['../view/platform/memberManagement/companyEdit.vue'], resolve)
            }
          ]
        }
      ]
    },
    {
      //询价采购管理(enquiry)
      path: '/enquiry/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/enquiry/auction.vue'], resolve)
            }
          ]
        },
        {
          //竞拍管理
          path: 'bid/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            //竞拍申请审核
            {
              path: 'verify',
              component: resolve => require(['../view/enquiry/bid/verify/verify.vue'], resolve)
            },
            //竞拍委托管理
            {
              path: 'trust',
              component: resolve => require(['../view/enquiry/bid/trust/trust.vue'], resolve)
            },
            {
              path: 'trust/:tr_id/resource',
              component: resolve => require(['../view/enquiry/bid/trust/resource.vue'], resolve)
            },
            {
              path: 'trust/:tr_id/member',
              component: resolve => require(['../view/enquiry/bid/trust/member.vue'], resolve)
            },
            //竞拍管理
            {
              path: 'manage',
              component: resolve => require(['../view/enquiry/bid/manage/manage.vue'], resolve)
            },
            //保证金管理
            {
              path: 'bzj',
              component: resolve => require(['../view/enquiry/bid/bzj/bzj.vue'], resolve),
            },
           
            {
              //-资源信息
              path: 'manage/:tr_id/resource',
              component: resolve => require(['../view/enquiry/bid/manage/resource.vue'], resolve)
            },
            {
              //-参加会员列表
              path: 'manage/:tr_id/member',
              component: resolve => require(['../view/enquiry/bid/manage/member.vue'], resolve)
            },
            {
              //-评标结果
              path: 'manage/:tr_id/result',
              component: resolve => require(['../view/enquiry/bid/manage/result.vue'], resolve)
            },
            {
              //-报价信息
              path: 'manage/:tr_id/offer',
              component: resolve => require(['../view/enquiry/bid/manage/offer.vue'], resolve)
            }
          ]
        },
        {
          //基本设置
          path: 'base/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //参数设置
              path: 'parameter',
              component: resolve =>
                require(['../view/enquiry/base/parameter/parameter.vue'], resolve)
            }
          ]
        },
        {
          //询价采购报表
          path: 'statistics/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              //询价采购情况统计
              path: 'procurement',
              component: resolve =>
                require(['../view/enquiry/statistics/procurement/procurement.vue'], resolve)
            }
          ]
        }
      ]
    },
    {
      path: '/auctionSale/:subsite_id',
      component: resolve => require(['../components/container.vue'], resolve),
      children: [
        {
          //竞价首页
          path: '',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'index',
              meta: {
                isIndex: true
              },
              component: resolve => require(['../view/bid/bid.vue'], resolve)
            }
          ]
        },
        {
          path: 'Auction/:menu_id',
          component: resolve => require(['../components/system.vue'], resolve),
          children: [
            {
              path: 'applicationReview',
              meta: {
                isIndex: true
              },
              component: resolve =>
                require([
                  '../view/auctionSale/Auction/applicationReview/applicationReview.vue'
                ], resolve)
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js